export const GET_ROSTERS = '[Rosters] Get Rosters';
export const GET_ROSTERS_SUCCESS = '[Rosters] Get Rosters Success';
export const GET_ROSTERS_ERROR = '[Rosters] Get Rosters Error';

export const LIST_ROSTER_ARTIST = '[Rosters] List Roster Artist';
export const LIST_ROSTER_ARTIST_SUCCESS =
  '[Rosters] List Roster Artist Success';
export const LIST_ROSTER_ARTIST_ERROR = '[Rosters] List Roster Artist Error';

export const CREATE_ROSTER = '[Rosters] Create Roster';
export const CREATE_ROSTER_SUCCESS = '[Rosters] Create Roster Success';
export const CREATE_ROSTER_ERROR = '[Rosters] Create Roster Error';

export const DELETE_ROSTER = '[Rosters] Delete Rosters';
export const DELETE_ROSTER_SUCCESS = '[Rosters] Delete Rosters Success';
export const DELETE_ROSTER_ERROR = '[Rosters] Delete Rosters Error';

export const UPDATE_ROSTER = '[Rosters] Update Roster';
export const UPDATE_ROSTER_SUCCESS = '[Rosters] Update Roster Success';
export const UPDATE_ROSTER_ERROR = '[Rosters] Update Roster Error';

export const UPDATE_ROSTER_RELATION = '[Rosters] Update Roster relation';
export const UPDATE_ROSTER_RELATION_SUCCESS =
  '[Rosters] Update Roster relation Success';
export const UPDATE_ROSTER_RELATION_ERROR =
  '[Rosters] Update Roster relation Error';

export const ATTACH_TO_ROSTER = '[Rosters] Attach to Roster';
export const ATTACH_TO_ROSTER_SUCCESS = '[Rosters] Attach to Roster Success';
export const ATTACH_TO_ROSTER_ERROR = '[Rosters] Attach to Roster Error';

export const REMOVE_FROM_ROSTER = '[Rosters] Remove from Roster';
export const REMOVE_FROM_ROSTER_SUCCESS =
  '[Rosters] Remove from Roster Success';
export const REMOVE_FROM_ROSTER_ERROR = '[Rosters] Remove  Roster Error';

export const LIST_ROSTER_OPERATORS = '[Rosters] List Roster Operators';
export const LIST_ROSTER_OPERATORS_SUCCESS =
  '[Rosters] List Roster Operators Success';
export const LIST_ROSTER_OPERATORS_ERROR =
  '[Rosters] List Roster Operators Error';

export const CREATE_ROSTER_OPERATOR = '[Rosters] Create Roster Operator';
export const CREATE_ROSTER_OPERATOR_SUCCESS =
  '[Rosters] Create Roster Operator Success';
export const CREATE_ROSTER_OPERATOR_ERROR =
  '[Rosters] Create Roster Operator Error';

export const REMOVE_OPERATOR_FROM_ROSTER =
  '[Rosters] Remove operator from Roster';
export const REMOVE_OPERATOR_FROM_ROSTER_SUCCESS =
  '[Rosters] Remove operator from Roster Success';
export const REMOVE_OPERATOR_FROM_ROSTER_ERROR =
  '[Rosters] Remove operator  Roster Error';
